// Client-specific company (workspace) IDs, used to gate per-client features.
//
// A workspace is identified by its company_id (from GET /auth/me ->
// userInfo.company_id). The same client can have separate workspaces on
// different backends - e.g. Superbank has a staging workspace on the staging BE
// and a production workspace on the prod BE - so we list all of them and match
// on whichever the logged-in user is in.
export const SUPERBANK_COMPANY_IDS = [
    "03fd32a5-a0a1-48b2-b612-7029d6a7c6f1", // superbank-staging  (staging BE)
    "0216a863-a212-43c4-b2cf-34b6fd0af953", // superbank-production (prod BE)
];

export function isSuperbankCompany(companyId?: string | null): boolean {
    return !!companyId && SUPERBANK_COMPANY_IDS.includes(companyId);
}
